const OFFSET_DESKTOP = 64
const OFFSET_MOBILE = 40
export const DEFAULT_STEP_DELAY_OFFSET = 200

let observer = null
let customStepDelayOffset = DEFAULT_STEP_DELAY_OFFSET

export function initAnimateObserver(stepDelayOffset = DEFAULT_STEP_DELAY_OFFSET) {
    if (customStepDelayOffset !== stepDelayOffset) customStepDelayOffset = stepDelayOffset
    if (observer) return observer

    observer = new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting }) => {
            if (!isIntersecting) return

            observer.unobserve(target)
            const index = +target.dataset.delayIndex || 0
            const timeout = target.dataset.delay ? index * customStepDelayOffset : 0

            setTimeout(() => {
                target.dataset.animate = 'true'
                target.dataset.delay = 'false'
            }, timeout)
        })
    }, {
        rootMargin: `0px 0px -${window.innerWidth > 1024 ? OFFSET_DESKTOP : OFFSET_MOBILE}px 0px`,
    })

    return observer
}

export function observeNewAnimateBlocks(stepDelayOffset = DEFAULT_STEP_DELAY_OFFSET, root = document) {
    const blocks = root.querySelectorAll('[data-animate="false"]')

    blocks.forEach((el, idx) => {
        if (!el.dataset.delayIndex) el.dataset.delayIndex = idx
        initAnimateObserver(stepDelayOffset).observe(el)
    })
}


// WEBPACK FOOTER //
// ./src/libs/animate/scroll.animate.js